<template>
  <div class="loginDialog" v-if="showLogin">
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["showLogin"]),
    iframeSrc() {
      return `${process.env.VUE_APP_LOGIN}?clientType=IYW`;
    },
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    ...mapActions(["setLoginShow"]),
    // 监听iframe传递的信息
    receiveMessage(event) {
      const data = event.data;
      if (data.type == "login") {
        // if (process.env.NODE_ENV == "development") {
        // 存储cookie
        document.cookie = `iyuanwu_token=${data.iyuanwu_token}`;
        // }
        this.$store.dispatch("setTokenMsg", data.iyuanwu_token);
      } else if (data.type == "close") {
        this.setLoginShow(false);
      }
    },
  },
};
</script>
<style lang="scss">
.loginDialog {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999999;

  iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
